module.exports = __webpack_public_path__ + "static/media/contact.789b0cad.jpg";